import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export function useMatch(id = "current", poll = 0) {
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    const r = await api.get(`/matches/${id}`);
    setData(r.data);
    return r.data;
  }, [id]);

  useEffect(() => {
    load().catch((e) => toast.error(errMsg(e)));
    if (!poll) return;
    const t = setInterval(() => document.visibilityState === "visible" && load().catch(() => {}), poll);
    return () => clearInterval(t);
  }, [load, poll]);

  const act = useCallback(
    async (method, path, body, okMsg) => {
      try {
        const r = await api[method](`/matches/${data.match.id}${path}`, body);
        setData(r.data);
        if (okMsg) toast.success(okMsg);
        return r.data;
      } catch (e) {
        toast.error(errMsg(e));
        return null;
      }
    },
    [data]
  );

  return { data, setData, load, act };
}
